import { Injectable } from '@angular/core';
import { routeFields } from '@medlogic/shared/shared-interfaces';
import { FhirGenericService } from './fhir-generic.service';

@Injectable({ providedIn: 'root' })
export class FhirFieldsService extends FhirGenericService {

  protected url = routeFields;

}
